import { render, staticRenderFns } from "./VehicleDriverDetails.vue?vue&type=template&id=4b362550&scoped=true&"
import script from "./VehicleDriverDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleDriverDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b362550",
  null
  
)

export default component.exports